export const api_v1_base = `/v1`;
export const api_v2_base = `/v2`;

export const API_ENDPOINTS = {
  LOGIN: () => {
    return `${api_v2_base}/authentication/login`;
  },
  REFRESH_TOKEN: () => {
    return `${api_v2_base}/authentication/refresh-auth-token`;
  },
  FORGOT_PASSWORD: () => {
    return `${api_v1_base}/authentication/forgot-password`;
  },
  RESET_PASSWORD: () => {
    return `${api_v1_base}/authentication/reset-password`;
  },
  HARD_RESET_PASSWORD: () => {
    return `${api_v1_base}/authentication/hard-reset-password`;
  },
  CONFIRM_PASSWORD: () => {
    return `${api_v1_base}/authentication/confirm-account`;
  },
  CHANGE_PASSWORD: (userId?: string) => {
    return `${api_v1_base}/users${userId ? `/${userId}` : ''}/password`;
  },
  USER: (userId?: string) => {
    return `${api_v1_base}/users${userId ? `/${userId}` : ''}`;
  },

  SING_UP: () => {
    return `${api_v2_base}/authentication/authentication/sign-up`;
  },
  SEND_CODE: () => {
    return `${api_v1_base}/authentication/send-code`;
  },
  SIGN_UP_V3: () => {
    return `${api_v1_base.replace('v1', 'v3')}/authentication/sign-up`;
  },
  CONFIRM_ACCOUNT_V1: () => {
    return `${api_v1_base}/authentication/confirm-account`;
  },
  VERIFY_CODE: () => {
    return `${api_v1_base}/authentication/verify-code`;
  },
  VERIFY_AUTH_TOKEN: () => {
    return `${api_v1_base}/authentication/verify-auth-token`;
  },
  CHECK_EMAIL_EXIST: () => {
    return `${api_v1_base.replace('v1', 'v3')}/authentication/check-email-exist`;
  },

  COMPANY: {
    GET_ALL: () => `${api_v1_base}/companies`,
    UPDATE: () => `${api_v1_base}/companies`,
    DELETE: (_company: string) => `${api_v1_base}/companies/${_company}`,
    CREATE: () => `${api_v1_base}/companies`,
    VALIDATE_COMPANY: () => `${api_v1_base}/companies/validate`,
    GET_BY_ID: (companyId: string) => `${api_v1_base}/companies/${companyId}`,
    CONTACT: (companyId: string) =>
      `${api_v1_base}/companies/${companyId}/send-email`,
    CHANGE_REQUEST_ACTION_TYPE: (companyId: string) =>
      `${api_v1_base}/companies/${companyId}/settings`,

    CANCEL_MEMBERSHIP: (companyId: string) =>
      `${api_v1_base}/companies/${companyId}/end-membership`,
  },

  USERS: {
    COUNT: () => `${api_v1_base}/users/count`,
    PROFILE_DATA: (userId: string) => `${api_v1_base}/users/${userId}`,
    CHANGE_PASSWORD: (userId: string) =>
      `${api_v1_base}/users/${userId}/password`,
    /**
     * This endpoints is pending
     */
    GET_ALL_APPROVERS: () => `${api_v1_base}/users`,

    CREATE: () => `${api_v1_base}/companies`,
    CREATE_COMPANY_MANAGER: () => `${api_v1_base}/authentication/sign-up`,
    GET_BY_ID: (companyId: string) =>
      `${api_v1_base}/companies/list?_id=${companyId}`,
    UPDATE_PHOTO: (userId: string) =>
      `${api_v1_base}/users/${userId}/profile-picture`,
    UPDATE: (userId: string) => `${api_v1_base}/users/${userId}`,
    RESEND_EMAIL: () => `${api_v1_base}/authentication/resend-confirm-account`,
  },

  REQUEST: {
    GET_BY_ID: (requestId: string) =>
      `${api_v1_base}/requests/list?_id=${requestId}&&populate=_approver`,
    CREATE: () => `${api_v1_base}/requests`,
    GET_ALL: () => `${api_v1_base}/requests`,
    UPSERT: () => `${api_v1_base}/requests/upsert`,
    APPROVE: () => `${api_v1_base}/requests/approve`,
    /**
     *
     * Improvement on Requests endpoints
     * july 14, 2022
     *
     */

    REQUESTS_COUNT: (userId?: string) => `${api_v1_base}/requests/count`,
    REQUEST_DETAILS: (_request: string) =>
      `${api_v1_base}/requests/${_request}`,
  },

  APPROVES: {
    GET_BY_ID: (requestId: string) =>
      `${api_v1_base}/requests?_id=${requestId}&populate=_requester`,
    CREATE: () => `${api_v1_base}/requests`,
    MY_APPROVES: (userId: string) =>
      `${api_v1_base}/requests?_approver=${userId}&populate=_requester`,
    APPROVE_REQUEST: (requestId: string) =>
      `${api_v1_base}/requests/${requestId}/approve`,
    DENY_REQUEST: (requestId: string) =>
      `${api_v1_base}/requests/${requestId}/deny`,
    // MY_APPROVALS_COUNT: (userId: string) =>
    //   `${api_v1_base}/requests/count?_approver=${userId}`,
    MY_APPROVALS_COUNT: (userId: string) => `${api_v1_base}/requests/count`,
  },

  MEMBER: {
    GET_ALL: () => `${api_v1_base}/members`,
    COUNT: () => `${api_v1_base}/members/count`,
    GET_BY_ID: (memberId: string) => `${api_v1_base}/members?_id=${memberId}`,
    CREATE: () => `${api_v1_base}/members`,
    DETAILS: () => `${api_v1_base}/members`,
    UPDATE: (memberId: string) => `${api_v1_base}/members/${memberId}`,
    DELETE: () => `${api_v1_base}/members`,
    MULTIPLE: () => `${api_v1_base}/members/multiple-members`,
    MULTIPLE_INVITE: () => `${api_v2_base}/members/multiple-members-invite`,
    REMOVE_ASSIGN: () => `${api_v1_base}/requests`,
  },

  REQUEST_ACTIONS: {
    GET: () => `${api_v1_base}/request-actions`,
    DELETE_UPDATE: (requestId: string) =>
      `${api_v1_base}/request-actions/${requestId}`,
    PATCH: (id: string, action: string) =>
      `${api_v1_base}/request-actions?_id=${id}&action=${action}`,
    CREATE: () => `${api_v1_base}/request-actions`,
  },

  MY_COMPANY: {
    GET_APPROVER: () => `${api_v1_base}/users/my-company/approvers`,
    GET_REQUESTS: () => `${api_v1_base}/users/my-company/requests`,
    GET_REQUESTS_ACTIONS: () =>
      `${api_v1_base}/users/my-company/request-actions`,
  },
  CLIENT: {
    CREATE: () => `${api_v1_base}/clients`,
    MY_CLIENT: () => `${api_v1_base}/clients`,
    UPDATE: (clientId: string) => `${api_v1_base}/clients?_id=${clientId}`,
    GET_REQUESTS: () => `${api_v1_base}/users/my-company/requests`,
  },
  PLANS: {
    GET_ALL: () => `${api_v1_base}/plans`,
    UPDATE: (subscriptionId: string) =>
      `${api_v1_base}/plans/${subscriptionId}`,
  },
  SUBSCRIPTIONS: {
    SUBSCRIBE: () => `${api_v1_base}/subscriptions`,
    UPDATE_MEMBERSHIP: (companyId: string) =>
      `${api_v1_base}/subscriptions/${companyId}`,
    CANCEL_MEMBERSHIP: (_subscription: string) =>
      `${api_v1_base}/subscriptions/${_subscription}/cancel`,
  },

  WALLET: {
    GET_ALL: (userId: string) =>
      `${api_v1_base}/users/${userId}/wallet/payment-methods`,
    ADD_CARD: (userId: string) =>
      `${api_v1_base}/users/${userId}/wallet/payment-methods`,
    DELETE_CARD: (userId: string, paymentMethod: string) =>
      `${api_v1_base}/users/${userId}/wallet/payment-methods/${paymentMethod}`,
  },
  CUSTOMER: {
    COUNT: () => `${api_v1_base}/customers/count`,
  },
  NOTIFICATIONS: {
    GET_ALL: () => `${api_v1_base}/notifications`,
    COUNT: () => `${api_v1_base}/notifications/count`,
    MARK_AS_READ: (notificationId: string) =>
      `${api_v1_base}/notifications/${notificationId}/read`,
  },
};
